import { defineMessages } from "react-intl";

import { useParsedFieldProps } from "./useParsedFieldProps";
import { SELECT } from "../SchemaTypes";
import Field from "../Field";
import SelectInput from "../../Input/SelectInput";
import { useFormatMessage } from "../../Intl/Context";

const SelectField = ({ schemaType = SELECT, ...props }) => {
  const { fieldProps, inputProps } = useParsedFieldProps(props);
  const { required, parent } = props;

  const schema = { type: schemaType, parent, validations: { required } };

  const t = useFormatMessage();
  const placeholder = props.placeholder || t(intlMessages.placeholder);

  return (
    <Field {...fieldProps} schema={schema}>
      <SelectInput {...inputProps} placeholder={placeholder} />
    </Field>
  );
};

export default SelectField;

export const intlMessages = defineMessages({
  placeholder: {
    id: "form.selectField.placeholder",
    defaultMessage: "Sélectionnez ..."
  }
});
